import { FC, memo, useEffect } from "react";
// 组件
import BasePageLayout from "./subpage/basePageLayout";
// 方法
import { login_web_getLoginInfo_api, login_web_logout_api } from '../api/login';
import { dict_web_getAllDict_api } from '../api/dict';
import { Navigate, } from 'react-router-dom';
// 常量
import { USER_NAME_KEY } from "../constants/localStorage";
import { PageLayoutProps } from "./interface";
import '../accest/styles/style.less';

/** 页面基本骨架 */
const PageLayout: FC<PageLayoutProps> = (props) => {
  const {
    menu = [],
    changePasswordApi = login_web_getLoginInfo_api,
    logoutApi = login_web_logout_api,
    getUserInfoApi = login_web_getLoginInfo_api,
    getDictApi = dict_web_getAllDict_api,
    maxCachePage,
    children,
  } = props;
  const token: string | null = window.localStorage.getItem(USER_NAME_KEY);
  useEffect(() => {
    window.sessionStorage.clear();
  }, []);
  // token不存在
  if (!token) {
    return <Navigate to='/login' />;
  }

  return (
    <>
      {
        token && (
          <>
            <BasePageLayout
              menu={menu}
              changePasswordApi={changePasswordApi}
              logoutApi={logoutApi}
              getUserInfoApi={getUserInfoApi}
              getDictApi={getDictApi}
              maxCachePage={maxCachePage}
            >
              {children}
            </BasePageLayout>
          </>
        )
      }
    </>
  );
};

export default memo(PageLayout);
